export default __webpack_public_path__ + "media/images/class-r-d408d17c572c5cef0a10ac24e3a97a2d.png";